import { atom } from 'jotai';

export const infoModalContent = atom<string>("");
export const set_pwd_modal_atom = atom<boolean>(false);
export const set_pwd_modal_warning = atom<string>("");
export const schedule_modal_content = atom<string>("");